import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Grid,
  Modal,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { takrarPranaliForm, getAllOffices } from "../utils/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import TopBarStatic from "./TopBarStatic";

const TakararPranaliForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    taluka_id: "",
    mobile_no: "",
    takrar: "",
    attachment_file: null,
  });

  const [offices, setOffices] = useState([]); // Store fetched office data
  const [errors, setErrors] = useState({});
  const [submittedId, setSubmittedId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [referenceNO, setReferenceNO] = useState(null);

  // Fetch all offices
  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const response = await getAllOffices();
        console.log(response.data, "Response Data");

        // Convert object to an array
        const officesArray = Object.entries(response.data.data).map(([id, name]) => ({
          id,
          name,
        }));

        setOffices(officesArray);
      } catch (error) {
        console.error("Error fetching offices:", error);
        setOffices([]);
      }
    };

    fetchOffices();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Select dropdown change
  const handleSelectChange = (event) => {
    setFormData((prev) => ({ ...prev, taluka_id: event.target.value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, attachment_file: file }));
  };

  // Validate form
  const validate = () => {
    let tempErrors = {};

    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.mobile_no) {
      tempErrors.mobile_no = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile_no)) {
      tempErrors.mobile_no = "Invalid mobile number";
    }
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }
    if (!formData.taluka_id) tempErrors.taluka_id = "Please select a Taluka";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("taluka_id", formData.taluka_id);
        formDataToSend.append("mobile_no", formData.mobile_no);
        formDataToSend.append("takrar", formData.takrar);
        if (formData.attachment_file instanceof File) {
          formDataToSend.append("attachment_file", formData.attachment_file);
        }

        const response = await takrarPranaliForm(formDataToSend);
        console.log("API Response:", response.data); // Debugging

        if (response.data && response.data.reference_no) {
          setSubmittedId(response.data.id);
          setReferenceNO(response.data.reference_no); // Set reference number
          setOpenModal(true); // Open the modal
          toast.success("Form submitted successfully!"); // Show success toast
        } else {
          toast.error("Reference number not found in response.");
        }

        // Reset form
        setFormData({
          name: "",
          email: "",
          taluka_id: "",
          mobile_no: "",
          takrar: "",
          attachment_file: null,
        });

        setErrors({});
      } catch (error) {
        console.error("Submission Error:", error);
        toast.error(error.response?.data?.message || "Submission failed");
      }
    }
  };

  // Copy ID to clipboard
  const handleCopy = () => {
    navigator.clipboard
      .writeText(referenceNO)
      .then(() => {
        toast.success("Reference number copied to clipboard!");
      })
      .catch((error) => {
        console.error("Copy failed:", error);
        toast.error("Failed to copy reference number.");
      });
  };

  return (
    <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
      <TopBarStatic />
      <Box
        sx={{
          maxWidth: 500,
          mx: "auto",
          mt: 4,
          p: 3,
          boxShadow: 1,
          borderRadius: 2,
          bgcolor: "#fff",
        }}
      >
        <ToastContainer position="top-right" autoClose={3000} />
        <Typography
          variant="h6"
          align="center"
          className="ff_yatra"
          sx={{ fontSize: "35px", padding: "10px" }}
        >
          तक्रार प्रणाली
        </Typography>
        <Typography
          variant="h3"
          align="center"
          sx={{
            color: "#000",
            mb: 2,
            fontSize: { xs: "22px", sm: "25px", md: "36px", lg: "44px" },
          }}
          className="ff_yatra"
        >
          सूचना व तक्रार प्रणाली  विभागीय आयुक्त कार्यालय, छत्रपती संभाजीनगर

        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={Boolean(errors.name)}
                helperText={errors.name}
              />
            </Grid>

            {/* Mobile */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mobile"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                error={Boolean(errors.mobile_no)}
                helperText={errors.mobile_no}
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={Boolean(errors.email)}
                helperText={errors.email}
              />
            </Grid>

            {/* Taluka Select Dropdown */}
            <Grid item xs={12}>
              <FormControl fullWidth error={Boolean(errors.taluka_id)}>
                <InputLabel>Select</InputLabel>
                <Select value={formData.taluka_id} onChange={handleSelectChange}>
                  {Array.isArray(offices) && offices.length > 0 ? (
                    offices.map((office) => (
                      <MenuItem key={office.id} value={office.id}>
                        {office.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No offices available</MenuItem>
                  )}
                </Select>

                {errors.taluka_id && <Typography color="error">{errors.taluka_id}</Typography>}
              </FormControl>
            </Grid>

            {/* Takrar */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="इथे आपली तक्रार नोंदवावी"
                name="takrar"
                multiline
                rows={4}
                value={formData.takrar}
                onChange={handleChange}
              />
            </Grid>

            {/* File Upload */}
            <Grid item xs={12}>
              <Button variant="outlined" component="label" fullWidth>
                Upload Attachment <AttachmentIcon sx={{ ml: "10px" }} />
                <input type="file" hidden onChange={handleFileChange} />
              </Button>

              {/* Show the selected file name */}
              {formData.attachment_file && (
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                    {formData.attachment_file.name}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFormData((prev) => ({ ...prev, attachment_file: null }))}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                तक्रार नोंदनी
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>

      {/* Modal to display submitted ID */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: "400px",
            maxWidth: "90%",
          }}
        >
          {/* Close Button */}
          <IconButton onClick={() => setOpenModal(false)} sx={{ position: "absolute", top: 8, right: 8 }}>
            <CloseIcon />
          </IconButton>

          {/* Submitted ID */}
          <Typography variant="h6" gutterBottom className="ff_baloo">
            Reference Number: <span className="bg-[#e0e0e0] font-bold mx-1 px-1">{referenceNO}</span>
          </Typography>

          {/* Red-colored Note */}
          <Typography
            variant="body2"
            sx={{
              color: "red",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Note: <span className="text-indigo-700">Please Copy Your Reference Number</span>
          </Typography>

          {/* Copy Button */}
          <Button
            onClick={handleCopy}
            variant="contained"
            startIcon={<ContentCopyIcon />}
            sx={{
              mt: 1,
              bgcolor: "#4caf50",
              "&:hover": { bgcolor: "#45a049" },
            }}
          >
            Copy ID
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default TakararPranaliForm;